import React, { useContext } from 'react';
import LocationSlider from '../locationslider/LocationSlider';
import iconLocation from '../../../images/icon-location.svg';
import styles from './CustomLocationCard.module.css';
import { AvailabilityRedirectionContext } from '../../context/availabilityRedirection';
import { getLocationTimeZone } from '../../../constants/constants';
import { locationsData } from '../../new-location-availability/interfaces/Availability.interface';

export interface locationProps {
    id: string;
    created_at: Date | string;
    updated_at: Date | string;
    name: string;
    street1: string;
    street2?: string;
    streetNumber: string;
    city: string;
    state: string;
    zip: string;
    country?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    adminId: string;
    images: string[];
    timeZone: string;
    description: string;
    confirmText: string;
    provisioningId: number;
    masterCode: string;
    mapUrl: string;
    pmsPropertyId?: string | null;
    yardiId: string;
    listOfPOI: string;
    lockerName: string;
}
export interface propGroup {
    location: locationsData;
    handleLocationCard?: (locationId: string | undefined) => void;
    selected?: boolean;
    lastElement?: any;
    noPointer?: boolean;
}

const CustomLocationCard = ({ location, handleLocationCard, selected, lastElement, noPointer }: propGroup) => {

    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);

    return (
        <div
            ref={lastElement}
            key={(location?.id ? location : availabilityRedirectionContext?.locationDetails)?.id}
            className={`${styles.locationCard} ${noPointer ? styles.noPointer : ''}`}
            onClick={() => handleLocationCard?.((location?.id ? location : availabilityRedirectionContext?.locationDetails)?.id)}>
            <div className={`${styles.card} ${selected ? styles.selected : ''}`}>
                <div className={`${location?.lockerName === 'BMS' ? styles.bmsStatusBadge : ''}`}>
                    {location?.lockerName === 'BMS' ? 'BMS' : ''}
                </div>
                <LocationSlider locationImgs={(location?.images ? location : availabilityRedirectionContext?.locationDetails)?.images} />
                <div className={styles.locationDetails}>
                    <div className={styles.cardTitle}>
                        <div className={styles.cardName}>
                            <span>{(location?.name ? location : availabilityRedirectionContext?.locationDetails)?.name}</span>
                            <span className={styles.provisioningId}>
                                (#{(location?.provisioningId ? location : availabilityRedirectionContext?.locationDetails)?.provisioningId})
                            </span>
                        </div>
                    </div>
                    <p className={styles.locationTime}>
                        {getLocationTimeZone(location?.timeZone ? location?.timeZone || "" : availabilityRedirectionContext?.locationDetails?.timeZone || "")}
                    </p>
                    <p className={styles.locationAddress}>
                        <img src={iconLocation} alt="Location" />
                        {`${(location?.street1 ? location : availabilityRedirectionContext?.locationDetails)?.street1}, ${(location?.streetNumber ? location : availabilityRedirectionContext?.locationDetails)?.streetNumber
                            ? `${(location?.streetNumber ? location : availabilityRedirectionContext?.locationDetails)?.streetNumber},`
                            : ''
                            } ${(location?.city ? location : availabilityRedirectionContext?.locationDetails)?.city}, ${(location?.state ? location : availabilityRedirectionContext?.locationDetails)?.state
                            }, ${(location?.zip ? location : availabilityRedirectionContext?.locationDetails)?.zip}`}
                    </p>
                    <p className={styles.locationDesc}>
                        {(location?.description ? location : availabilityRedirectionContext?.locationDetails)?.description}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CustomLocationCard;
